export class EntitySupply4project {
public c_supply_id:number | null = null;
public c_project_id:number | null = null;
public c_supply_rownum:number | null = null;
public c_claim_id:number | null = null;
public c_supply_climnum_tmp:number | null = null;
public c_supply_claim_date:Date | null = null;
public c_supply_month:Date | null = null;
public c_supply_item:number | null = null;
public c_supply_subject:number | null = null;
public c_supply_breakdown:number | null = null;
public c_supplier_id:number | null = null;
public c_supply_price:number | null = null;
public c_supply_taxrate:number | null = null;
public c_supply_date_exp_payment:Date | null = null;
public c_supply_flag_paid:number | null = null;
public c_supply_remarks:string | null = null;
public c_supply_flag_lock:number | null = null;
public c_supply_reg_user:string | null = null;
public c_supply_reg_at:Date | null = null;
public c_supply_upd_user:string | null = null;
public c_supply_upd_at:Date | null = null;
public c_claim_status:number | null = null;
public c_supply_flag_chkclaim:number | null = null;
}